const isIElasticErrorResponse = (obj) => {
    return obj.error !== undefined;
};
export default isIElasticErrorResponse;
